import { render, staticRenderFns } from "./Talbe.vue?vue&type=template&id=0228de5d&scoped=true&"
import script from "./Talbe.vue?vue&type=script&lang=js&"
export * from "./Talbe.vue?vue&type=script&lang=js&"
import style0 from "./Talbe.vue?vue&type=style&index=0&id=0228de5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0228de5d",
  null
  
)

export default component.exports